import { Heart, Instagram } from "lucide-react";
import { gallery } from "../../data/gallery";
import { site } from "../../data/siteConfig";
import { Reveal } from "../Reveal";

const mockPosts = gallery.slice(0, 6).map((g, i) => ({
  ...g,
  likes: [42, 38, 51, 29, 47, 33][i] || 30,
}));

export const InstagramSection = () => (
  <section className="px-5 py-16 md:py-24" data-testid="instagram-section">
    <div className="mx-auto max-w-7xl">
      <Reveal className="mb-10 text-center">
        <p className="font-script text-3xl text-hotpink">follow the looks</p>
        <h2 className="mt-2 font-serif text-4xl md:text-5xl">
          {site.instagram.handle}
        </h2>
        <p className="mt-3 text-sm text-white/50">
          Fresh styles drop on Instagram first — come see the latest.
        </p>
      </Reveal>

      <Reveal>
        <div className="no-scrollbar flex snap-x snap-mandatory gap-4 overflow-x-auto pb-4 lg:grid lg:grid-cols-6 lg:overflow-visible">
          {mockPosts.map((p) => (
            <a
              key={p.id}
              href={site.instagram.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group w-48 shrink-0 snap-start overflow-hidden rounded-2xl border border-white/10 bg-coal lg:w-auto"
              data-testid={`ig-mock-${p.id}`}
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="flex items-center justify-between px-3 py-2.5 text-xs text-white/60">
                <span className="flex items-center gap-1.5">
                  <Heart className="h-3.5 w-3.5 fill-hotpink text-hotpink" />
                  {p.likes}
                </span>
                <Instagram className="h-3.5 w-3.5 text-white/40" />
              </div>
            </a>
          ))}
        </div>
      </Reveal>

      <Reveal className="mt-10 text-center">
        <a
          href={site.instagram.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="ig-follow-button"
          className="inline-flex items-center gap-2 rounded-full border border-hotpink px-9 py-4 text-xs font-bold uppercase tracking-[0.25em] text-hotpink transition-colors duration-300 hover:bg-hotpink hover:text-white"
        >
          <Instagram className="h-4 w-4" />
          Follow on Instagram
        </a>
        <p className="mt-4 text-[11px] text-white/30">
          Mock feed — curated Instagram posts will replace these tiles later.
        </p>
      </Reveal>
    </div>
  </section>
);

